import React from "react";
import AlertMessage from "../../../../Components/alertMessage";
import { BeneficiaryFormRv } from "../../beneficiaryFormRv";
import IconHolder from "../../../../Resources/svg/Icons/IconHolder";
import moment from "moment";

interface UpdateBeneficiaryCardProps {
  selectedBeneficiary: any;
  showWarningUserValidation: boolean;
  handleValidateUser: (state: boolean) => void;
  submitBeneficiary: (data: any) => Promise<void>;
  isOpen: boolean;
}

const UpdateBeneficiaryCard = ({
  selectedBeneficiary,
  showWarningUserValidation,
  handleValidateUser,
  submitBeneficiary,
  isOpen,
}: UpdateBeneficiaryCardProps) => {
  return (
    <>
      <div className="card-verify card-verify_rv">
        <div className="card-verify__header">
          <IconHolder />
          <div className="card-verify__title"> BENEFICIARIO</div>
        </div>
        <div className="card-verify__body">
          <div className="card-verify__quote">Nombres:</div>
          <div className="card-verify__data">
            {selectedBeneficiary.primerNombre}{" "}
            {selectedBeneficiary.segundoNombre
              ? selectedBeneficiary.segundoNombre
              : ""}
          </div>
        </div>
        <div className="card-verify__body">
          <div className="card-verify__quote">Apellidos:</div>
          <div className="card-verify__data">
            {selectedBeneficiary.apellidoPaterno +
              " " +
              selectedBeneficiary.apellidoMaterno}
          </div>
        </div>
        <div className="card-verify__body">
          <div className="card-verify__quote">Fecha de nacimiento:</div>
          <div className="card-verify__data">
            {moment(selectedBeneficiary.fechaNacimiento).format("DD/MM/YYYY")}
          </div>
        </div>
      </div>

      <div className="card-verify card-verify_rv">
        <div className="card-verify__header">
          <IconHolder />
          <div className="card-verify__title"> OTROS DATOS</div>
        </div>
        {showWarningUserValidation && (
          <AlertMessage
            background="#FFEFD8"
            margin="0 0px -16px"
            icono={alert}
            mensaje="Parece que los nombres y apellidos no coinciden con el número de documento. Revisa que los datos estén correctos e inténtalo nuevamente."
          />
        )}
        <BeneficiaryFormRv
          beneficiary={selectedBeneficiary}
          existsErrors={false}
          type={"BENEFICIARY"}
          validationBeneficiary={(state: any) => handleValidateUser(state)}
          onSubmit={submitBeneficiary}
          isOpen={isOpen}
        ></BeneficiaryFormRv>
      </div>
    </>
  );
};

export default UpdateBeneficiaryCard;
